import { FormsEvents } from './../enum/tracking/forms-events.enum';
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as vmasker from 'vanilla-masker';
import * as opentip from '../scripts/tooltip.js';
import { OrderMarketTypeEnum } from './../enum/orders/market-type.enum';
import { SecurityCategory } from './../enum/security-category.enum';
import errorsDefault from './../resources/errors.js';

@Injectable({ providedIn: 'root' })
export class UtilitiesService {
  // tslint:disable-next-line: no-empty
  constructor() {}

  public getSuitabilityDescription(profile) {
    switch (profile) {
      case 1:
        return 'Indefinido';
      case 2:
        return 'Conservador';
      case 3:
        return 'Moderado';
      case 4:
        return 'Arrojado';
      default:
        return 'Indefinido';
    }
  }

  /**
   * Ordena uma lista por data da maior pra menor.
   * @param dateA Data A.
   * @param dateB Data B.
   * @param order (asc, desc) Ordem da lista.
   */
  public sortArrayByDate(
    dateA: string,
    dateB: string,
    order: string = 'ASC'
  ): number {
    const date1: any = new Date(dateB);
    const date2: any = new Date(dateA);
    return order.equals('asc') ? date2 - date1 : date1 - date2;
  }

  public Once(fn: any, context: any) {
    let result: any;

    return function () {
      if (fn) {
        result = fn.apply(context || this, arguments);
        fn = null;
      }

      return result;
    };
  }

  /**
   * Funcão que normaliza as keys de um objeto ou array
   * @param item array ou objeto para ser normalizado
   */
  public normalize(item) {
    if (!item) return;
    const result: any = Array.isArray(item) ? [] : {};
    Object.keys(item).forEach((key) => {
      if (typeof item[key] === 'object' && item[key]) {
        if (Array.isArray(item)) {
          result.push(this.normalize(item[key]));
        } else {
          result[this.normalizeAttributeName(key)] = this.normalize(item[key]);
        }
      } else {
        result[this.normalizeAttributeName(key)] = item[key];
      }
    });
    return result;
  }

  public PoupancaCalc(value: any, period: any) {
    const arrResult: any = [];

    arrResult.push(value);

    for (let index = 0; index < period; index++) {
      value = Math.floor(value * 0.06 + value);
      arrResult.push(value);
    }

    return arrResult;
  }

  public calculateMonth(value: any, type: string = 'date') {
    let monthsValue;
    if (type === 'date') {
      monthsValue = value;
      if (!/^\d+$/.test(value)) {
        const d1 = new Date();
        const d2 = new Date(value);
        monthsValue = (d2.getFullYear() - d1.getFullYear()) * 12;
        monthsValue -= d1.getMonth() + 1;
        monthsValue += d2.getMonth();
        monthsValue = monthsValue <= 0 ? 0 : monthsValue + 1;
      }
    } else {
      monthsValue = +value / 30;
    }

    if (monthsValue < 0) {
      return 'MÊS NEGATIVO';
    }

    let stringMonth: string = '';
    let years: number = 0;
    let months: number = 0;

    if (+monthsValue / 12 > 0) {
      years = Math.floor(+monthsValue / 12);
    }

    months = Math.floor(+monthsValue - years * 12);

    if (years > 0) {
      if (years > 1) {
        stringMonth += years + ' anos';
      } else {
        stringMonth += years + ' ano';
      }
    }
    if (months > 0 && years > 0) {
      stringMonth += ' e ';
    }
    if (months > 0) {
      if (months > 1) {
        stringMonth += months + ' meses';
      } else {
        stringMonth += months + ' mês';
      }
    }
    return stringMonth;
  }

  public monthDiff(d1, d2) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  public CDBCalc(value: any, period: any) {
    // tslint:disable-next-line: prefer-const
    let arrResult: any = [];

    arrResult.push(value);

    for (let index = 0; index < period; index++) {
      value = Math.floor(value * 0.12 + value);
      arrResult.push(value);
    }

    return arrResult;
  }

  public BanksCalc(value: any, period: any) {
    // tslint:disable-next-line: prefer-const
    let arrResult: any = [];

    arrResult.push(value);

    for (let index = 0; index < period; index++) {
      value = Math.floor(value * 0.08 + value);
      arrResult.push(value);
    }

    return arrResult;
  }

  /* Formato um valor monetário */
  public formatCurrencyValue(value, c = 2, d = ',', t = '.'): string {
    let n = value;
    let j;
    c = isNaN((c = Math.abs(c))) ? 2 : c;
    d = d === undefined ? '.' : d;
    t = t === undefined ? ',' : t;
    const s = n < 0 ? '-' : '';
    const i: any = String(+(n = Math.abs(Number(n) || 0).toFixed(c)));
    // tslint:disable-next-line: no-conditional-assignment
    j = (j = i.length) > 3 ? j % 3 : 0;
    return (
      s +
      (j ? i.substr(0, j) + t : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
      (c
        ? d +
          Math.abs(n - i)
            .toFixed(c)
            .slice(2)
        : '')
    );
  }

  /* Gera um novo guid (identificador universal unico)*/
  public guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      s4() +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  }

  /**
   * Seta um form control como um controle de entrada de valores monetários com suporte a máscara.
   * @param control Form control
   * @param precision Precisão
   */
  public setControlAsCurrencyInput(
    control: AbstractControl,
    precisionCurrency: number = 2
  ): void {
    control.valueChanges.subscribe((value) => {
      const formatedValue = vmasker.toMoney(value || '', {
        delimiter: '.',
        precision: precisionCurrency,
        separator: ',',
        unit: 'R$',
        zeroCents: false,
      });
      control.setValue(formatedValue, { emitEvent: false });
    });
    control.setValue(control.value, { emitEvent: false });
  }

  public isMobile(): boolean {
    return window.innerWidth <= 767;
  }

  /**
   * Formata e retorna uma data no padrão HH:mm
   * @param date: data a ser formatada
   */
  public getFormattedHour(date: Date, includeSeconds: boolean = true): string {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;
    return includeSeconds
      ? hours + ':' + minutesFormatted + ':' + seconds
      : hours + ':' + minutesFormatted;
  }

  /**
   * Bind a tooltip to element
   */
  public bindTooltipContent(
    element: any,
    tooltipContent: string,
    direction: string = 'top',
    targetBind: any = null
  ) {
    return new opentip(element, tooltipContent, '', {
      background: '#FFF',
      borderColor: 'transparent',
      borderRadius: 0,
      className: 'tooltip',
      extends: 'glass',
      fixed: true,
      removeElementsOnHide: true,
      shadowBlur: 20,
      shadowOffset: [1, 1],
      stemBase: 15,
      stemLength: 15,
      target: targetBind,
      tipJoint: direction,
    });
  }

  public lazyBindTooltipContent(
    trigger: string,
    element: any,
    tooltipContent: string
  ) {
    return $(element).on(trigger, () => {
      let lazyTip;

      lazyTip = new opentip(element, tooltipContent, '', {
        background: '#FFF',
        borderColor: 'transparent',
        borderRadius: 0,
        className: 'tooltip',
        extends: 'glass',
        fixed: true,
        removeElementsOnHide: true,
        shadowBlur: 20,
        shadowOffset: [1, 1],
        stemBase: 15,
        stemLength: 15,
        tipJoint: 'top',
      });
      lazyTip.show();
    });
  }

  /** Remove os valores não numéricos da string de formato R$ 9.009,00 */
  public getOnlyNumbersFromMonetaryRepresentation(value: string): number {
    if (!value) return 0;

    if (typeof value === 'number') return value;

    const numberValue = value.toString().replace(/[^0-9]/g, '');
    return value.indexOf('R$') !== -1 ? +numberValue / 100 : +numberValue;
  }

  public anchorElement(elementSelector) {
    const fieldAnchor = $(elementSelector);

    $('.tr-wrapper-two-columns').animate(
      {
        scrollTop: $(fieldAnchor).offset().top,
      },
      1000
    );
  }

  /** Verifica se uma dada data é de um fim de semana (sábado ou domingo) */
  /**
   *  Verifica se uma dada data é de um fim de semana (sábado ou domingo)
   *
   * @param data data para comparar se ela é ou não fim de semana
   */
  public isWeekendDate(data: Date): boolean {
    const day = data.getDay();

    return day === 6 || day === 0;
  }

  /**
   * Função que diminui um dia útil (considerando apenas fim de semana) da data passada
   *
   * @param data passa data que deve ser diminuida em um dia útil
   */
  public lessOneDay(data: Date) {
    let newDate = data;
    do {
      newDate = new Date(newDate.setDate(newDate.getDate() - 1));
    } while (this.isWeekendDate(newDate));
    return newDate;
  }

  /**
   * Element Scroll to
   *
   * @param to valor inteiro para aonde o scroll vai
   * @param duration tempo de animacão até o lugar
   * @param el elemento que ira ser scrollado (window || div)
   */
  // tslint:disable-next-line: no-empty
  public elementScrollTo(el, to, duration, callback = () => {}) {
    // start in current position scroll window || element
    const start = el.scrollTop;
    // distancia entre o start e o final
    const change = to - start;
    // current time to next scroll
    let currentTime = 0;
    // increment time after current scroll
    const increment = 20;

    /**
     * expression to animate scroll
     *
     * @param t current time
     * @param b start value
     * @param c change in value
     * @param d duration
     */
    const easeInOutQuad = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    // execute scroll
    const animateScroll = () => {
      currentTime += increment;

      // scroll window || element
      el.scrollTop = easeInOutQuad(currentTime, start, change, duration);

      // timer
      if (currentTime < duration) {
        setTimeout(animateScroll, increment); // proxima vez que o scroll ira rodar!
      } else {
        callback();
      }
    };
    animateScroll();
  }

  /**
   *
   * Window scroll to
   *
   * @param destination destino do scroll
   * @param duration duracão do scroll, tempo entre o inicio e o final do scroll
   * @param easing suavização do movimento de scroll
   * ( linear, easeInQuad, easeOutQuad, easeInOutQuad, easeInCubic, easeOutCubic, easeInOutCubic, easeInQuart,
   * easeOutQuart, easeInOutQuart, easeInQuint, easeOutQuint, easeInOutQuint)
   * @param callback funcão de callback
   */
  // tslint:disable-next-line: no-empty
  public windowScrollTo(
    destination,
    duration = 200,
    easing = 'linear',
    callback = () => {}
  ) {
    const easings = {
      linear(t) {
        return t;
      },
      easeInQuad(t) {
        return t * t;
      },
      easeOutQuad(t) {
        return t * (2 - t);
      },
      easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      },
      easeInCubic(t) {
        return t * t * t;
      },
      easeOutCubic(t) {
        return --t * t * t + 1;
      },
      easeInOutCubic(t) {
        return t < 0.5
          ? 4 * t * t * t
          : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      },
      easeInQuart(t) {
        return t * t * t * t;
      },
      easeOutQuart(t) {
        return 1 - --t * t * t * t;
      },
      easeInOutQuart(t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
      },
      easeInQuint(t) {
        return t * t * t * t * t;
      },
      easeOutQuint(t) {
        return 1 + --t * t * t * t * t;
      },
      easeInOutQuint(t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
      },
    };

    const start = window.pageYOffset;

    const startTime =
      'now' in window.performance ? performance.now() : new Date().getTime();

    // tamanho do elemento a ser scrollado
    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    );

    // tamanho da janela que exibe o elemento
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.getElementsByTagName('body')[0].clientHeight;

    const destinationOffset =
      typeof destination === 'number' ? destination : destination.offsetTop;
    const destinationOffsetToScroll = Math.round(
      documentHeight - destinationOffset < windowHeight
        ? documentHeight - windowHeight
        : destinationOffset
    );

    if ('requestAnimationFrame' in window === false) {
      window.scroll(0, destinationOffsetToScroll);
      // el.scrollTop = destinationOffsetToScroll

      if (callback) {
        callback();
      }
      return;
    }

    const scroll = () => {
      const now =
        'now' in window.performance ? performance.now() : new Date().getTime();
      const time = Math.min(1, (now - startTime) / duration);
      const timeFunction = easings[easing](time);

      window.scroll(
        0,
        Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start)
      );

      // if (Math.ceil(window.pageYOffset) === destinationOffsetToScroll) {
      if (window.pageYOffset >= destinationOffsetToScroll - 30) {
        if (callback) {
          callback();
        }
        return;
      }

      requestAnimationFrame(scroll);
    };

    scroll();
  }

  public cleanByRegex(value: string, valueReplace: string, regex: any): string {
    return value.replace(regex, valueReplace);
  }

  /**
   * Remove acentos de caracteres
   * @param  {String} actualString [string que contem os acentos]
   * @return {String}                 [string sem acentos]
   */
  public removeAccents(actualString) {
    let stringRead = actualString;
    if (!stringRead) return '';

    const mapaAcentosHex = {
      A: /[\xC0-\xC6]/g,
      C: /\xC7/g,
      E: /[\xC8-\xCB]/g,
      I: /[\xCC-\xCF]/g,
      N: /\xD1/g,
      O: /[\xD2-\xD6]/g,
      U: /[\xD9-\xDC]/g,
      a: /[\xE0-\xE6]/g,
      c: /\xE7/g,
      e: /[\xE8-\xEB]/g,
      i: /[\xEC-\xEF]/g,
      n: /\xF1/g,
      o: /[\xF2-\xF6]/g,
      u: /[\xF9-\xFC]/g,
    };

    for (const letra in mapaAcentosHex) {
      if (mapaAcentosHex[letra]) {
        const expressaoRegular = mapaAcentosHex[letra];
        stringRead = stringRead.replace(expressaoRegular, letra);
      }
    }

    return stringRead;
  }

  public setMaskCPF(document: number | string) {
    if (!document) return;
    return vmasker.toPattern(document, '999.999.999-99');
  }

  public setMaskCNPJ(document: number | string) {
    if (!document) return;
    return vmasker.toPattern(document, '99.999.999/9999-99');
  }

  /**
   * Entrar no modo tela cheia
   * @param document elemento para entrar em modo tela cheia
   */
  public goFullscreen(document: any) {
    // go full-screen
    if (document.requestFullscreen) {
      document.requestFullscreen();
    } else if (document.webkitRequestFullscreen) {
      document.webkitRequestFullscreen();
    } else if (document.mozRequestFullScreen) {
      document.mozRequestFullScreen();
    } else if (document.msRequestFullscreen) {
      document.msRequestFullscreen();
    }
  }

  /**
   *
   * Gera nome para URL amigável de acordo com nome passado como parâmetro
   *
   * @param name Nome a ser convertido
   */
  public generateFriendlyURL(name: string) {
    if (name) {
      name = name
        .replace(/[^a-zA-Z0-9]/g, ' ')
        .replace(/\s+/g, '-')
        .toLowerCase();
      if (name.charAt(0) === '-') name = name.substring(1);
      const last = name.length - 1;
      if (name.charAt(last) === '-') {
        name = name.substring(0, last);
      }
      return name;
    }
    return name;
  }

  /**
   * Sair do modo tela cheia
   * @param document elemento para sair do modo tela cheia
   */
  public exitFullscreen(document: any) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }

  /**
   * Cria um slug a partir de uma dada string
   * @param str string a ser tranformada
   * https://gist.github.com/codeguy/6684588
   */
  public createSlug(str: string) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
    const to = 'aaaaeeeeiiiioooouuuunc------';
    for (let index = 0, l = from.length; index < l; index++) {
      str = str.replace(new RegExp(from.charAt(index), 'g'), to.charAt(index));
    }

    str = str
      .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes

    return str;
  }

  /**
   * Calcula idade do usuário
   *
   * @param { String } dateBirth Data no formato de ISOString
   */
  public calcAgeUser(dateBirth) {
    const dateActual = new Date();
    dateBirth = new Date(dateBirth);
    return Math.floor(
      Math.ceil(
        Math.abs(dateBirth.getTime() - dateActual.getTime()) /
          (1000 * 3600 * 24)
      ) / 365.25
    );
  }

  /**
   * Função para retornar a diferença de tempo entre duas datas. Adaptação do momment.js.
   * @param { Date } date1 Primeira data a ser comparada - deve ser a mais recente.
   * @param { Date } date2 Segiunda data a ser comparada - deve ser a mais antiga.
   * @param { string } units ['year', 'month', 'quarter', 'second', 'minute', 'hour', 'day', 'week'] Unidade de tempo a ser medida a diferença.
   * @param { boolean } [asFloat=false] Se retorna número arredondado ou decimal.
   */
  public diffTime(date1, date2, units, asFloat: boolean = false) {
    let that;
    let zoneDelta;
    let output;

    that = date2;

    // if (!that.isValid()) { return NaN; }
    zoneDelta = 0 * 6e4;

    switch (units) {
      case 'year':
        output = this.mommentMonthDiff(date1, that) / 12;
        break;
      case 'month':
        output = this.mommentMonthDiff(date1, that);
        break;
      case 'quarter':
        output = this.mommentMonthDiff(date1, that) / 3;
        break;
      case 'second':
        output = (date1 - that) / 1e3;
        break; // 1000
      case 'minute':
        output = (date1 - that) / 6e4;
        break; // 1000 * 60
      case 'hour':
        output = (date1 - that) / 36e5;
        break; // 1000 * 60 * 60
      case 'day':
        output = (date1 - that - zoneDelta) / 864e5;
        break; // 1000 * 60 * 60 * 24, negate dst
      case 'week':
        output = (date1 - that - zoneDelta) / 6048e5;
        break; // 1000 * 60 * 60 * 24 * 7, negate dst
      default:
        output = date1 - that;
    }

    return asFloat ? output : Math.round(Math.floor(output));
  }

  public trasnformDate(value: any, format: string) {
    let date = value;
    const datePipe = new DatePipe('en-US');

    try {
      let dateFormatted = `${date.substr(0, 4)}/${date.substr(
        5,
        2
      )}/${date.substr(8, 2)} `;
      dateFormatted += `${date.substr(11, 2)}:${date.substr(
        14,
        2
      )}:${date.substr(17, 2)}`;
      date = new Date(dateFormatted);
      date = datePipe.transform(date, format);
    } catch (e) {
      date = '';
    }

    return date;
  }

  /**
   * Verifica se é um token JWT válido
   * @param token token para verificação
   */
  public isValidJwtToken(token: string): boolean {
    const helper = new JwtHelperService();
    try {
      const valid = helper.decodeToken(token);
      return !!valid;
    } catch (error) {
      // console.warn('Cant parse jwt token.');
      return false;
    }
  }

  public normalizeAttributeName(name: string) {
    const nameLower = name.charAt(0).toLowerCase();
    return name === 'ID' || name === 'CBLC'
      ? name.toLowerCase()
      : nameLower + name.slice(1);
  }

  /**
   * Extrai do JWT informado o valor de uma dada key
   * @param token token jwt
   * @param key key
   */
  public extractJwtKeyValue(token: string, key: string): string {
    if (!this.isValidJwtToken(token)) {
      // console.warn(`Invalid JWT. Can't extract ${key} from informed JWT token.`);
      return null;
    }

    const jwtHelper = new JwtHelperService();

    try {
      const data = jwtHelper.decodeToken(token);
      return data[key];
    } catch (error) {
      // console.warn('A unexpected error has ocurred while trying to get JWT key value.');
      return null;
    }
  }

  /**
   * Realiza merge de um objeto indexável com novos itens
   * @param previousVersion versão anterior do objeto
   * @param items novos itens
   * @param indexerAttrName nome do atributo a ser usado como index
   */
  public static mergeIndexableObject(
    previousVersion: any,
    items: any[],
    indexerAttrName: string = 'id'
  ) {
    return {
      ...previousVersion,
      ...items.reduce((all, currentItem, index, allData) => {
        return { ...all, ...{ [currentItem[indexerAttrName]]: currentItem } };
      }, {}),
    };
  }

  /**
   * Realiza merge de um objeto indexável com novos itens validando a variação e último preço de negociação
   * @param previousVersion versão anterior do objeto
   * @param items novos itens
   * @param indexerAttrName nome do atributo a ser usado como index
   */
  public static mergeQuoteApiIndexableObject(
    previousVersion: any,
    items: any[],
    indexerAttrName: string = 'id'
  ) {
    return {
      ...previousVersion,
      ...items.reduce((all, currentItem, index, allData) => {
        const previousItem = previousVersion[currentItem[indexerAttrName]];
        if (previousItem) {
          if (currentItem.PriceLastTrade == null)
            currentItem.PriceLastTrade = previousItem.PriceLastTrade;
          if (currentItem.Variation == null)
            currentItem.Variation = previousItem.Variation;
          if (currentItem.HighestPriceDay == null)
            currentItem.HighestPriceDay = previousItem.HighestPriceDay;
          if (currentItem.LowestPriceDay == null)
            currentItem.LowestPriceDay = previousItem.LowestPriceDay;
          if (currentItem.DateTimeLastTrade == null)
            currentItem.DateTimeLastTrade = previousItem.DateTimeLastTrade;
          if (currentItem.ClosingPricePreviousDay == null)
            currentItem.ClosingPricePreviousDay =
              previousItem.ClosingPricePreviousDay;
          if (currentItem.OpeningPrice == null)
            currentItem.OpeningPrice = previousItem.OpeningPrice;
          if (currentItem.TypeMarket == null)
            currentItem.TypeMarket = previousItem.TypeMarket;
          if (currentItem.Stress == null)
            currentItem.Stress = previousItem.Stress;
          if (currentItem.Market == null)
            currentItem.Market = previousItem.Market;
        } else if (currentItem.Stress == null) {
          currentItem.Stress = { IsPTax: false };
        }
        return { ...all, ...{ [currentItem[indexerAttrName]]: currentItem } };
      }, {}),
    };
  }

  /**
   * Realiza merge de um objeto indexável com novos itens
   * @param previousVersion versão anterior do objeto
   * @param items novos itens
   * @param indexerAttrName nome do atributo a ser usado como index
   */
  public static mergeTrendIndexableObject(
    previousVersion: any,
    item: any,
    indexerAttrName: string,
    interval: string
  ) {
    return {
      ...previousVersion,
      ...{
        [indexerAttrName]: {
          ...{},
          ...previousVersion[indexerAttrName],
          ...{ [item[interval]]: item },
        },
      },
    };
  }

  /**
   * Recupera uma representação de data em formato dd/MM/yyyy
   * @param value respresentação da data a ser formatada
   */
  public static getFormattedDate(value: string) {
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return value;

    const actualDate = new Date();
    const date = new Date(value);
    date.setUTCHours(actualDate.getUTCHours());
    // tslint:disable-next-line: newline-per-chained-call
    const day =
      date.getDate().toString().length < 2
        ? '0' + date.getDate().toString()
        : date.getDate().toString();
    let month;

    if ((date.getMonth() + 1).toString().length < 2) {
      month = '0' + (date.getMonth() + 1).toString();
    } else {
      month = (date.getMonth() + 1).toString();
    }

    return day + '/' + month + '/' + date.getFullYear();
  }

  public static normalizeSecturityCategory(instruments: any[]) {
    const TYPE_STOCK_MARKET_BOV_FRACTIONARY = '10';
    const TYPE_STOCK_MARKET_ETF_FRACTIONARY = '13';

    instruments.forEach((instrument) => {
      if (instrument.secutiryCategory) return;

      if (
        `${instrument.code}`.length === 8 &&
        instrument.typeMarket !== OrderMarketTypeEnum.Option
      ) {
        instrument = {
          ...instrument,
          securityCategory: SecurityCategory.StocksFuture,
        };
      } else {
        instrument = {
          ...instrument,
          securityCategory: SecurityCategory.Undefined,
        };
      }

      if (instrument.typeStockCode === TYPE_STOCK_MARKET_BOV_FRACTIONARY)
        instrument.typeMarket = OrderMarketTypeEnum.Fractionary;
      else if (instrument.typeStockCode === TYPE_STOCK_MARKET_ETF_FRACTIONARY)
        instrument.typeMarket = OrderMarketTypeEnum.ETFFractionary;
    });

    return instruments;
  }

  /**
   * Função auxiliar da função diffTime
   * @param a primeira Data
   * @param b segunda Data
   */
  private mommentMonthDiff(a, b) {
    // difference in months
    const wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month());
    const anchor = a.clone().add(wholeMonthDiff, 'months');
    let anchor2;
    let adjust;

    if (b - anchor < 0) {
      anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
      // linear across the month
      adjust = (b - anchor) / (anchor - anchor2);
    } else {
      anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
      // linear across the month
      adjust = (b - anchor) / (anchor2 - anchor);
    }

    // check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
  }
}
